import debounce from "lodash/debounce";
import scrollbarWidth from "scrollbar-width";
import { loadPolyfills } from "./lib/polyfills";
import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";

/**
 * Expose "real" height of 1vh as `--vh` CSS custom property
 * See https://css-tricks.com/the-trick-to-viewport-units-on-mobile/ for details
 */
function exposeViewportHeight() {
  const vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

/**
 * Expose scrollbar width as `--scrollbar-width` CSS custom property
 * This allows as to properly size a fixed element
 */
function exposeScrollbarWidth() {
  const width = scrollbarWidth();

  document.documentElement.style.setProperty("--scrollbar-width", `${width}px`);
}

const root = document.getElementById("root");

if (root) {
  const config = (() => {
    try {
      const parsed = JSON.parse(root.dataset.config);

      return parsed;
    } catch (err) {
      return {};
    }
  })();
  const prefilled = (() => {
    try {
      const prefilled = window.location.hash.match(/#prefilled=(.+)/, "");
      const parsed = JSON.parse(prefilled[1]);

      return parsed;
    } catch (err) {
      return null;
    }
  })();

  (async () => {
    // Larger polyfills
    await loadPolyfills();

    // Expose viewport height to CSS
    exposeViewportHeight();

    window.addEventListener(
      "resize",
      debounce(() => exposeViewportHeight(), 100)
    );

    // Expose scrollbar width to CSS
    document.addEventListener("DOMContentLoaded", () => {
      exposeScrollbarWidth();
    });

    // Render app
    ReactDOM.render(
      <React.StrictMode>
        <App {...config} prefilled={prefilled} />
      </React.StrictMode>,
      root
    );
  })();
}
